/**
 * @file SectionList atom — sectioned list primitive.
 * @description Structured atom: parts re-exported from the vendored Gluestack
 * family; the only sanctioned import path for app code (RFC §3).
 * @module components/atoms/SectionList
 */
export { SectionList } from "@/components/ui/section-list";
